import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromRoot from 'src/app/state/app.selectors';
import * as fromEventSponsorship from './event-sponsorship.reducers';

export interface EventSponsorshipState {
  stateData: fromEventSponsorship.State;
}

export interface State extends fromRoot.AppState {
  eventSponsorship: EventSponsorshipState;
}

export const reducers = {
  stateData: fromEventSponsorship.reducer
};

export const selectEventSponsorshipState = createFeatureSelector<EventSponsorshipState>('eventSponsorship');

export const selectEventSponsorshipStateData = createSelector(selectEventSponsorshipState, (state: EventSponsorshipState) => state.stateData);

export const getEventSponsorshipState = createSelector(selectEventSponsorshipStateData, fromEventSponsorship.getStateData);

export const getEventSponsorshipScreenError = createSelector(selectEventSponsorshipStateData, fromEventSponsorship.getError);

export const getEventSponsorshipScreenPending = createSelector(selectEventSponsorshipStateData, fromEventSponsorship.getPending);